import mod from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalNuovaTratta.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalNuovaTratta.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ModalNuovaTratta.vue?vue&type=script&lang=js&
// module id = 409
// module chunks = 0